import { useSurveyWidgetQuery } from '@hotjar/feedback/domain/Surveys/query';
import { ForwardResults } from '@hotjar/feedback/components/common/ForwardResults';
import { useCurrentSite } from '@hotjar/site';
import { WebhooksFeature } from '@hotjar/integrations';

export const ForwardSurveyResults = ({
  surveyId,
  onEdit,
  trackingUiPosition,
  trackingState,
}: {
  surveyId: number;
  onEdit: () => void;
  trackingUiPosition: string;
  trackingState: string;
}): JSX.Element | null => {
  const { data: site } = useCurrentSite();
  const { data: survey } = useSurveyWidgetQuery(site?.id, surveyId);
  const webhooksEnabled = WebhooksFeature.canUse(site);

  const emailForwardingEnabled =
    survey !== undefined ? survey.forwarding_email_address_list.length > 0 : false;

  if (site === undefined) return null;

  return (
    <ForwardResults
      siteId={site.id}
      widgetType="poll"
      onEdit={onEdit}
      hasEmailForwarding
      hasSlackForwarding
      hasMsTeamsForwarding
      hasWebhooksForwarding={webhooksEnabled}
      hasZapierEnabled
      widgetId={surveyId}
      emailEnabled={emailForwardingEnabled}
      trackingUiPosition={trackingUiPosition}
      trackingState={trackingState}
    />
  );
};
